import { notifyOnError } from '~/rage/decorators';
import { IObservable, Subject } from '~/rage/utils';
import { IClientConfigs, IVehicleRegistrationDetails } from '~/shared';
import { BackendService } from '../BackendService';
import { GameConfigService } from '../GameConfigService';
import { RpcService } from '../RpcService';
import { IVehicleRegistrationService } from './vehicleRegistrationServiceTypes';

export class VehicleRegistrationService implements IVehicleRegistrationService {
	private readonly registrationPrice = new Subject<number | null>(null);

	constructor(
		private readonly backend: BackendService,
		private readonly rpc: RpcService,
		gameConfig: GameConfigService,
	) {
		gameConfig.getConfigs().subscribe((configs: Partial<IClientConfigs>) => {
			if (!configs || !configs.vehicleRegistration) return;
			this.registrationPrice.next(
				configs.vehicleRegistration.registrationPrice,
			);
		});
	}

	@notifyOnError
	public async getDetails(
		vehicleId: string,
	): Promise<IVehicleRegistrationDetails | null> {
		return await this.backend.invoke<IVehicleRegistrationDetails | null>(
			'vehicleRegistration:getDetails',
			{ vehicleId },
		);
	}

	public getRegistrationPrice(): IObservable<number | null> {
		return this.registrationPrice;
	}

	@notifyOnError
	public async register(vehicleId: string, region: string): Promise<void> {
		return await this.backend.invoke('vehicleRegistration:register', {
			vehicleId,
			region,
		});
	}

	public async exitMenu(): Promise<void> {
		return await this.rpc.invokeClient('vehicleRegistration:exitMenu');
	}
}
